import { createFeatureSelector, createSelector } from '@ngrx/store'
import { GatewayLogState } from './gateway-log.state'

export const paymentGatewayLogState = createFeatureSelector<GatewayLogState>('gateway-logs')

export const selectLog = (paymentGatewayId) =>
  createSelector(paymentGatewayLogState, (s: GatewayLogState) => {
    return (s && s[paymentGatewayId]) || []
  })
